<template>
    <div class="installation-instructions">
      <div class="page-content-container page-content-container--no-header" id="page-content-container">
        <p
          v-if="instructions.title || instructions.titleTx"
          class="instruction-page-title"
          :name="`${instructions.currentStep}_pageTitle`"
          :id="`${instructions.currentStep}_pageTitle`"
        >{{ instructions.titleTx ? $t(instructions.titleTx) : instructions.title }}</p>
  
        <div class="page-content">
          <p
            v-if="instructions.primaryText || instructions.primaryTx"
            class="instruction-title"
            :name="`${instructions.currentStep}_primaryText`"
            :id="`${instructions.currentStep}_primaryText`"
          >{{ instructions.primaryTx ? $t(instructions.primaryTx) : instructions.primaryText }}</p>
          <p
            :name="`${instructions.currentStep}_secondaryText`"
            :id="`${instructions.currentStep}_secondaryText`"
            :class="['instruction-subtitle', instructions.additionalSecondaryTextClasses]"
          >{{ instructions.secondaryTx ? $t(instructions.secondaryTx) : instructions.secondaryText }}</p>
  
          <BaseSteps
            v-if="instructions.steps && instructions.steps.length > 0"
            :instructions="instructions"
            :brandTheme="brandTheme"
          />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import BaseSteps from '../../components/BaseSteps.vue';
  
  import { mapState } from 'vuex';
  import { get } from 'lodash';
  
  export default {
    name: 'BluetoothPairingHelp',
    components: {
      BaseSteps,
    },
    data() {
      return {
        instructions: {
          primaryTx: 'help.bluetooth.title',
          secondaryTx: 'help.bluetooth.subtitle',
          steps: [
            {
              stepNumber: 1,
              titleTx: 'help.bluetooth.step1.title',
              descriptionTx: 'help.bluetooth.step1.description'
            },
            {
              stepNumber: 2,
              titleTx: 'help.bluetooth.step2.title',
              descriptionTx: 'help.bluetooth.step2.description'
            },
            {
              stepNumber: 3,
              titleTx: 'help.bluetooth.step3.title',
              descriptionTx: 'help.bluetooth.step3.description'
            }
          ],
        }
      }
    },
    computed: {
      ...mapState(['brands']),
      brand() {
        const { brand } = this.$route.params;
        return brand ? brand : 'pepper';
      },
      brandTheme() {
        return get(this, ['brands', this.brand, 'theme'], {});
      },
    },
    beforeCreate() {
      let { brand } = this.$route.params;
      if (!brand) {
        brand = 'pepper';
      }
      document.body.classList.add(brand);
    }
  };
  </script>
  